<h1 class="text-lg font-medium">{{ title() }}</h1>
@if (subtitle()) {
  <p class="text-sm color-contrast-medium">{{ subtitle() }}</p>
}
